import { createFileRoute, Outlet } from '@tanstack/react-router';

import { backendApiStationsFindOneOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

export const Route = createFileRoute('/_authenticated/management/stations/$stationId')({
  component: Outlet,
  beforeLoad: async ({ params: { stationId }, context: { queryClient } }) => {
    const stationData = await queryClient.ensureQueryData(
      backendApiStationsFindOneOptions({
        path: { stationId },
      }),
    );

    return {
      breadcrumb: stationData?.name,
    };
  },
});
